{
  "id": "cosmos",
  "name": "Cosmos",
  "description": "Deep space — cosmic blues, nebula purples and comet trails",
  "colors": {
    "light": {
      "primary": "#2e5bff",
      "secondary": "#d6deff",
      "positive": "#12a87a",
      "negative": "#e4384f",
      "warning": "#d99a00",
      "important": "#f26419",
      "light": "#f1f4fc",
      "dark": "#0a0e1a",
      "surface": "#e2e8f7",
      "darksurface": "#141a2c",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#5ca8ff",
      "secondary": "#3a2e5c",
      "positive": "#3ddc97",
      "negative": "#ff5c7a",
      "warning": "#f5c542",
      "important": "#ff8a3d",
      "light": "#dde3f0",
      "dark": "#0a0e1a",
      "surface": "#dde3f0",
      "darksurface": "#141a2c",
      "white": "#ffffff"
    }
  }
}
